import { render, staticRenderFns } from "./GlobalSpinner.vue?vue&type=template&id=a4971d06&"
import script from "./GlobalSpinner.vue?vue&type=script&lang=js&"
export * from "./GlobalSpinner.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports